module.exports = __webpack_public_path__ + "img/EDED06_B5B504_CCCC04_D4D404-256px.9ea1dc55.png";